import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  chamadas: [],
  centroDeCustos: [],
  conferencias: [],
  tags: [],
  dadosRelatorio: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
